import { Admin, Resource } from 'react-admin';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import { ProductList, ProductEdit, ProductCreate } from './resources/products';
import { CategoryList, CategoryEdit, CategoryCreate } from './resources/categories';
import { BrandList, BrandEdit, BrandCreate } from './resources/brands';
import { BlogList, BlogEdit, BlogCreate } from './resources/blogs';
import { OrderList, OrderEdit } from './resources/orders';
import { UserList, UserEdit, UserCreate, UserShow } from './resources/users';
import { ContactUsList } from './resources/contactUs';
import { AddressList } from './resources/adresses';
import { SearchLogList, SearchLogShow } from './resources/searchLogs';
import { ContactUsLogList, ContactUsLogShow } from './resources/contactUsLogs';
import { ImportList, ImportShow } from './resources/imports';
import { authProvider } from './authProvider';
import { dataProvider } from './dataProvider';

const App = () => (
  <Admin 
    dataProvider={dataProvider}
    authProvider={authProvider}
    requireAuth
  >
    <Resource 
      name="users" 
      list={UserList} 
      edit={UserEdit}
      create={UserCreate}
      show={UserShow}
      options={{ label: 'Users' }}
    />
    <Resource 
      name="products" 
      list={ProductList} 
      edit={ProductEdit} 
      create={ProductCreate} 
    />
    <Resource 
      name="categories" 
      list={CategoryList} 
      edit={CategoryEdit} 
      create={CategoryCreate} 
    />
    <Resource 
      name="brands" 
      list={BrandList} 
      edit={BrandEdit} 
      create={BrandCreate} 
    />
    <Resource 
      name="blogs" 
      list={BlogList} 
      edit={BlogEdit} 
      create={BlogCreate}
      options={{ label: 'Blog Posts' }}
    />
    <Resource 
      name="orders" 
      list={OrderList} 
      edit={OrderEdit}
      options={{ label: 'Orders' }}
    />
    <Resource 
      name="contact-us" 
      list={ContactUsList} 
      options={{ label: 'Contact Us' }}
    />
    <Resource 
      name="addresses" 
      list={AddressList} 
      options={{ label: 'Addresses' }}
    />
            <Resource 
          name="search-logs" 
          list={SearchLogList} 
          show={SearchLogShow}
          options={{ label: 'Search Logs' }} 
        />
        <Resource 
          name="contact-us-logs" 
          list={ContactUsLogList} 
          show={ContactUsLogShow}
          options={{ label: 'Contact Us Logs' }} 
        />
        <Resource 
          name="imports" 
          list={ImportList} 
          show={ImportShow}
          icon={UploadFileIcon}
          options={{ label: 'Product Imports' }} 
        />
  </Admin>
);

export default App; 